module.exports = __webpack_public_path__ + "img/78.37c8d8d8.jpg";